// @ts-nocheck
import styled, { css } from 'styled-components';
import {
    spanishViridian25,
    scarpaGray200,
    scarpaGray500,
    scarpaGray800,
    spanishViridian500,
    spanishViridian600,
    error,
    robotoRegular,
    tomatoCoral100,
    spanishViridian50,
    maximumYellow100,
} from '@habitech/shared';
import { GridContainer } from 'src/components/common/grids';

export const Title = styled.div`
    font-size: 24px;
    font-weight: bold;
    color: ${scarpaGray800};
`;

export const Container = styled.div`
    width: 100%;
    max-width: 750px;
    margin: auto;
    &.process-list {
        width: 100%;
        overflow-y: auto;
        max-width: 100% !important;
    }
`;

export const WrapperButton = styled.div`
    max-width: 250px;
    margin: auto;
    button {
        margin: auto;
    }
`;

export const SearchWrapper = styled(GridContainer)`
    padding: 32px 0;
    align-items: baseline;
`;

export const TextBasic = css`
    font-size: 16px;
    margin: 16px 0;
`;

export const UploadButton = styled.div`
    .drop-container {
        position: relative;
        display: flex;
        gap: 2px;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        height: 80px;
        padding: 10px;
        border-radius: 10px;
        border: 2px dashed ${scarpaGray200};
        color: ${scarpaGray500};
        cursor: pointer;
        transition: background 0.2s ease-in-out, border 0.2s ease-in-out;
        &.error {
            border-color: ${error};
        }
    }

    .drop-container:hover {
        background: ${spanishViridian25};
        border-color: ${spanishViridian500};
    }

    .drop-container:hover .drop-title {
        color: ${scarpaGray200};
    }

    .drop-title {
        color: ${scarpaGray500};
        font-size: 16px;
        font-weight: bold;
        text-align: center;
        transition: color 0.2s ease-in-out;
    }

    input[type='file'] {
        display: none;
        width: 100%;
        max-width: 400px;
        color: ${scarpaGray500};
        background: #fff;
        border-radius: 16px;
        border: 1px solid ${scarpaGray200};
        height: 34px;
    }

    input[type='file']::file-selector-button {
        margin-right: 10px;
        border: none;
        background: white;
        padding: 8px 16px;
        border-radius: 100px;
        color: ${spanishViridian500};
        cursor: pointer;
        height: 32px;
        border: 1px solid ${spanishViridian500};
        transition: background 0.2s ease -in -out;
        z-index: 1;
        position: relative;
    }

    input[type='file']::file-selector-button:hover {
        background: ${spanishViridian600};
        color: white;
    }
    .error-text {
        font-size: 12px;
        line-height: 14px;
        color: ${error};
        padding: 8px 0;
        font-family: ${robotoRegular};
    }
    &.images {
        margin: 16px 0;
        input[type='file'] {
            display: none;
        }
        &.modal .drop-container {
            height: 35px;
        }
    }
    &.disabled {
        .drop-container:hover {
            background: white;
            border-color: ${scarpaGray200};
        }

        .drop-container:hover .drop-title {
            color: inherit;
        }
        input[type='file']::file-selector-button {
            border-color: ${scarpaGray200};
            color: ${scarpaGray200};
        }
        input[type='file']::file-selector-button:hover {
            background: inherit;
            color: inherit;
        }
    }
`;

export const DownButton = styled.div`
    width: 30px;
    height: 30px;
    display: block;
    margin: auto;
    svg path {
        fill: ${spanishViridian500};
    }
`;

export const DeleteButton = styled.div`
    width: 28px;
    height: 28px;
    display: block;
    margin: auto;
    margin-top:8px;
    svg path {
        fill: ${error};
    }
`;

export const LabelStatus = styled.div`
    padding: 4px 6px 6px;
    border-radius: 5px;
    font-size: 14px;
    font-weight: bold;
    text-align: center;
    &.pendiente {
        background-color: ${maximumYellow100};
    }
    &.exitoso {  
        background-color: ${spanishViridian50};
    }
    &.fallo {
        background-color: ${tomatoCoral100};
    }
`;


export const TextModal = styled.div`
    font-size: 22px;
    text-align: center;
    margin: 48px 24px;
`